module.exports = __webpack_public_path__ + "media/images/icon_pr-529f44dc4e1f6640991555b3b8acb533.png";